import { IBizEntity, IBizEntityType } from '@optima-stride-ai/core';

/**
 * Creates a new default IBizEntity for entity-creation forms.
 *
 * @param type      - The IBizEntityType to assign to the entity.
 * @param parentId  - The parent entity ID (or empty string for root).
 * @param icon      - CoreUI icon identifier (e.g. 'cilLibrary', 'cilFile').
 * @param labels    - Labels to apply to the entity (e.g. ['Folder'], ['File']).
 * @param overrides - Optional field overrides; use to explicitly set tenantId/appId
 *                    when they should differ from the type's values.
 */
export function createNewBizEntity(
  type: IBizEntityType,
  parentId: string,
  icon: string,
  labels: string[],
  overrides?: { tenantId?: string; appId?: string }
): IBizEntity {
  return {
    id: '',
    name: '',
    shortName: '',
    description: '',
    icon,
    parentId,
    tenantId: overrides?.tenantId !== undefined ? overrides.tenantId : type.tenantId,
    appId: overrides?.appId !== undefined ? overrides.appId : type.appId,
    ownerId: '',
    draft: false,
    additionalInfo: [],
    archived: false,
    archivedBy: null,
    archivedOn: null,
    createdOn: new Date(),
    createdBy: null,
    type,
    labels,
  };
}
